import { SelectListItem } from '../shared/select-list-item';

export interface UserDemographicSelectList {
  id: string;
  identifier: string;
  name: string;
  demographics: SelectListItem[];
  selectedItem: string;
  validationMessage: string;
}
